import React from "react";

const LOGO_SRC = "/branding/inter-view-logo.svg";
const LOGO_FALLBACK = "/branding/inter-view-logo.png";

/**
 * Inter-View brand wordmark — the approved logo extracted from the
 * customer-supplied AI source file. Native aspect ratio is ~5.1 : 1
 * (228.1 × 44.6 pt). Always render at the natural aspect ratio so
 * the wordmark is never stretched or squashed; `height` is the only
 * dimension the caller controls.
 *
 * The SVG ships as a public static asset (not a JS-imported module)
 * so webpack's SVGR loader doesn't try to parse the inkscape-namespace
 * elements PyMuPDF leaves in the file. PNG fallback for very old
 * browsers that don't render SVG.
 */
export default function Logo({
  height = 32,
  className = "",
  priority = false,
  ...rest
}) {
  const [src, setSrc] = React.useState(LOGO_SRC);
  return (
    <img
      src={src}
      alt="Inter-View"
      height={height}
      style={{ height, width: "auto" }}
      className={`select-none ${className}`}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
      onError={() => {
        if (src !== LOGO_FALLBACK) setSrc(LOGO_FALLBACK);
      }}
      data-testid="inter-view-logo"
      {...rest}
    />
  );
}
